// extracted by mini-css-extract-plugin
export default {"recos":"V3-z","productCardOverride":"W3-z","rowHasBadge":"X3-z"};